(function () {

    angular
        .module('smartertoolsApp')
        .controller('cartModifyLicenseController',
            [
                '$scope', '$location', 'moment', 'authenticationService', '$rootScope', '$http',
                cartModifyLicenseController
            ]);

    function cartModifyLicenseController($scope, $location, moment, authenticationService, $rootScope, $http) {
        const vm = this;
        let autoNav = $location.search().LicenseKey;
        vm.searchText = $location.search().LicenseKey;
        vm.loginRequired = !authenticationService.isLoggedIn();
        vm.hasHighAvailability = authenticationService.hasHighAvailability();

        // Functions
        vm.modifyProductUpdateOption = modifyProductUpdateOption;
        vm.currentTotal = currentTotal;
        vm.addModificationToCart = addModificationToCart;
        vm.showLoginOverlay = showLoginOverlay;
        vm.refreshLicenseList = refreshLicenseList;
        vm.modifyProductQueryOptions = modifyProductQueryOptions;
        vm.upgradeProtectionWarnClass = upgradeProtectionWarnClass;
        vm.friendlyUpgradeProtectionDate = friendlyUpgradeProtectionDate;
        vm.chooseLicenseToModify = chooseLicenseToModify;
        vm.showLicenseList = showLicenseList;
        vm.doResellerSearch = doResellerSearch;
        vm.switchToModSection = switchToModSection;

        activate();

        // -----------------------------------------------

        function activate() {
            vm.cartGuid = SessionStorageWithFallback.get('smartertoolsCartGuid');
            vm.renewMode = $location.path() === '/renew-license';
            vm.licenseKey = null;
            vm.loginRequired = !authenticationService.isLoggedIn();
            vm.licenses = null;
            vm.isReseller = authenticationService.isReseller();
            vm.licenseTab = '';
            vm.modificationState = {
                licenseKey: vm.licenseKey,
                selections: {LicenseKey: vm.licenseKey}
            };

            autoSpinner = true;
            vm.refreshLicenseList();
            getBack();

            $rootScope.$on('authentication:logged-in', (event, data) => {
                vm.loginRequired = !authenticationService.isLoggedIn();
            });
            $rootScope.$on('authentication:logged-out', (event, data) => {
                vm.loginRequired = !authenticationService.isLoggedIn();
            });
        }

        function modifyProductUpdateOption(key, val) {
            vm.modificationState.selections[key] = val;
            vm.modifyProductQueryOptions();
        }

        function switchToModSection(section) {
            vm.modificationState.state.CurrentSection = section;
        }

        function currentTotal() {
            return vm.modificationState.state ? vm.modificationState.state.Total + 0 : 0;
        }

        function addModificationToCart() {
            vm.modificationState.selections.CartId = vm.cartGuid;
            let data = vm.modificationState.selections;
            
            $http.post(`${apiRootUrl}v1/cart/modify-license-add`, JSON.stringify(data))
                .then(response => {
                    let data2 = response.data;
                    vm.cartGuid = data2.CartId;
                    SessionStorageWithFallback.set('smartertoolsCartGuid', vm.cartGuid);
                    $location.path('/');
                    $scope.$applyAsync();
                }, () => {
                });
        }

        function showLoginOverlay() {
            ShowLoginOverlay(() => {
                vm.refreshLicenseList();
                $scope.$applyAsync();
            });
        }

        function refreshLicenseList() {
            if (!authenticationService.isLoggedIn()) {
                vm.loginRequired = true;
                vm.isReseller = authenticationService.isReseller();
            } else {
                $http.post(`${apiRootUrl}v1/cart/user-licenses`, JSON.stringify({CartId: vm.cartGuid}))
                    .then(response => {
                        let data = response.data;
                        vm.licenses = data.Licenses;
                        vm.isReseller = authenticationService.isReseller();
                        vm.loginRequired = false;
                        vm.licenseKey = null;
                        if (autoNav && vm.licenses) {
                            for (let i = 0; i < vm.licenses.length; i++) {
                                const l = vm.licenses[i];
                                if (l.LicenseKeyString == autoNav) {
                                    chooseLicenseToModify(l.LicenseKeyString);
                                }
                            }
                            autoNav = null;
                        }
                        $scope.$applyAsync();
                    }, () => {
                        vm.loginRequired = true;
                        vm.isReseller = authenticationService.isReseller();
                        $scope.$applyAsync();
                    });
            }
        }

        function modifyProductQueryOptions() {
            vm.modificationState.selections.LicenseKey = vm.licenseKey;
            $http.post(`${apiRootUrl}v1/cart/modify-license-options`, JSON.stringify(vm.modificationState.selections))
                .then(response => {
                    vm.modificationState.state = response.data;
                    vm.modificationState.state.Sections.forEach(function (p) {
                        vm.modificationState.selections[p.Key] = p.Selected;
                    });
                    $scope.$applyAsync();
                }, () => {
                });
        }

        function upgradeProtectionWarnClass(expiration) {
            let up = new Date(expiration);
            let today = new Date();
            let warnPeriod = new Date();
            warnPeriod.setDate(today.getDate() + 60);
            let isPast = up < today;
            let isWarn = !isPast && up < warnPeriod;
            return isPast ? 'past' : isWarn ? 'warn' : '';
        }

        function friendlyUpgradeProtectionDate(expiration) {
            if (new Date(expiration) < new Date())
                return 'Expired ' + (new moment(expiration)).format('ll');
            else
                return 'Expires ' + (new moment(expiration)).format('ll');
        }

        function chooseLicenseToModify(licenseKeyString) {
            vm.licenseKey = licenseKeyString;
            vm.modificationState.selections = {};
            vm.modifyProductQueryOptions();
            window.scrollTo(0, 0);
        }

        function showLicenseList(licenseKeyString) {
            vm.licenseKey = null;
            vm.modificationState.selections = {};
            window.scrollTo(0, 0);
        }

        function doResellerSearch(licenseKeyString) {
            let lk = vm.resellerSearchText.replace(/[^a-fA-F0-9]/g, '');
            let lk2 = '';
            for (let i = 0, len = lk.length; i < len; i++) {
                if (i !== 0 && (i % 6) === 0)
                    lk2 += '-';
                lk2 += lk.charAt(i);
            }
            vm.resellerSearchText = lk2;
            vm.resellerSearchPerformed = false;

            $http.post(`${apiRootUrl}v1/cart/reseller-license-search`, JSON.stringify({
                LicenseKeyString: lk2,
                CartId: vm.cartGuid
            }))
                .then(response => {
                    let data = response.data;
                    if (data && data.Licenses && data.Licenses.length > 0)
                        vm.resellerSearchTextResults = data.Licenses[0];
                    else
                        vm.resellerSearchTextResults = null;
                    vm.resellerSearchPerformed = true;
                    $scope.$applyAsync();

                    const resellerSearchLicenseKeyBox = document.getElementById('resellerSearchLicenseKeyBox');
                    resellerSearchLicenseKeyBox.select();
                    resellerSearchLicenseKeyBox.focus();
                }, () => {
                });
        }

        function getBack() {
            const stg = sessionStorage.getItem('modifyLicense_back');
            vm.modifyLicense = vm.modifyLicense || {};
            vm.modifyLicense.back = stg
                ? JSON.parse(stg)
                : {display: 'Select Product', url: '/purchase/select-product'};
            sessionStorage.removeItem('modifyLicense_back');
        }
    }

})();